import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DashboardTabs } from '../property-view.component';
import { IPropertyDetails } from '../../shared/models/propertydetails';
import { AuthenticationService } from '../../shared/auth/authentication.service';
import { PropertyListingService } from '../../shared/providers/property-listing.service';
import { ActivatedRoute, Params } from '@angular/router';

@Component({
  selector: 'app-property-dashboard',
  templateUrl: './property-dashboard.component.html',
  styleUrls: ['./property-dashboard.component.css']
})
export class PropertyDashboardComponent implements OnInit {

  constructor(public _authenticationService: AuthenticationService,
    private _propertyService: PropertyListingService, protected activatedRoute: ActivatedRoute) { }
  dashboardTabs = DashboardTabs;
  dashboardActiveTab = this.dashboardTabs.Dashboard;
  @Input() propertyGuid: string = "";
  @Input() propertyId: number = 0;
  @Input() IsPortfolio: boolean;
  @Input() property = {} as IPropertyDetails;
  @Input() AccessAdded: number = 0;
  @Input() offerstatusid: number;
  @Input() offerGuid: string = "";
  public IsFromSource: number = 1;
  prospectTabVisibility = false as boolean;
  dashboardTabVisibility = false as boolean;
  propsectMennuId: number;
  user: any;
  propertydata: any
  @Output() viewPlaceOffer = new EventEmitter();
  ngOnInit() {

    this.user = this._authenticationService.user as any;
    this.prospectTabVisibility = (this._authenticationService.Broker() && this.property.BrokersId.includes(this.user.Id))
      || this._authenticationService.Admin()
      || this._authenticationService.SuperAdmin()
      || (this.property.ShowProspectToSeller && this.property.SellerId.includes(this.user.Id));

    this.dashboardTabVisibility = (this._authenticationService.Broker() && this.property.BrokersId.includes(this.user.Id))
      || this._authenticationService.Admin()
      || this._authenticationService.SuperAdmin()
      || (this.property.PropertyStatus != 'Off-Market' && this.property.SellerId.includes(this.user.Id));
    this.propertydata = this.property;
    this.offerstatusid = this.propertydata.OfferStatusId;
    this.offerGuid = this.propertydata.OfferGuid;

    if (localStorage.getItem('property-dashboard-Tab') != null && localStorage.getItem('property-dashboard-Tab') != '' && localStorage.getItem('property-dashboard-Tab') != undefined) {
      let tabItem = localStorage.getItem('property-dashboard-Tab');
      localStorage.removeItem('property-dashboard-Tab');
      this.onDashboardTabClick(Number(tabItem));
      var element = document.getElementById("property-dashboard-innertabs");
      this.scrollToTop(element, 350);
    }
   
  }


scrollToTop(element, offset) {
  //this.scrollService.scrollTo(element, offset);
  $('html,body').animate({ scrollTop: ($(element).offset().top - offset) }, 500);
}

onDashboardTabClick(tab: number) {
  this.dashboardActiveTab = tab;
  this.propsectMennuId = -1;
  if (localStorage.getItem('currentFileRefreshTab') != undefined && localStorage.getItem('currentFileRefreshTab') != null) {
    localStorage.removeItem('currentFileRefreshTab');
  }
  this._propertyService.getPropertyDetails(this.propertyGuid, this.user.Id).subscribe(response => {
    if (response != null && !response.IsAccessDenied && !response.IsPropertyExist) {
      this.propertydata = response;
      this.offerstatusid = this.propertydata.OfferStatusId;
      this.offerGuid = this.propertydata.OfferGuid;
    }
  });
}

loadProspect(type: any) {
  this.propsectMennuId = type.id;
  this.dashboardActiveTab = this.dashboardTabs.Prospects;
}
showPlaceOffer(offerVisiblity) {
  this.viewPlaceOffer.emit(offerVisiblity);
}
}
